import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { navigate, useQueryParams } from "raviger";
import {
  Card,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import { SystemErrorContext } from '../components/SystemError';
import { AuthContext } from "./AccountsReducer";
import Header from '../components/Header';

const TemporaryAccessRegistration = ({ organization, id }) => {

  // Identify any query param data.
    const [queryParams] = useQueryParams();

  const { setShowSystemError } = useContext(SystemErrorContext);
  const { state } = useContext(AuthContext);

  const [data, setData] = useState({id:'', org_name:'', incident:null, incident_name:'', link_expires_at:null});

  const [success, setSuccess] = useState(null);

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    const fetchTempAccess = async () => {
      // Fetch Temporary Access data.
      await axios.get('/incident/api/tempaccess/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
          // If temp access is still valid.
          if (new Date(new Date(response.data.link_expires_at.replace(/-/g, '\/')).toDateString()) >= new Date(new Date().toDateString())) {
            const values = {'user':state.user.id, 'access_link':id};
            // If user is logged in, create AccessRequest.
            axios.post('/accounts/api/accessrequest/', values)
            .then(response => {
              setSuccess(true);
            })
            .catch(error => {
              setShowSystemError(true);
              setSuccess(false);
            });
          }
          else {
            setSuccess(false)
          }
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    if (state.user.id) {
      fetchTempAccess();
    }

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id, state.user.id]);

  return (
    <>
    <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization)} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
        {data.org_name} - Access Request Submitted
      </Header>
      <div className="row mt-1">
        <div className="col-8 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              {success ? <span>An Access Request has been submitted for Incident{" " + data.incident_name || ""}! Your access to the incident will be available once an administrator has approved your access request.</span> : ""}
              {success === false ? <span>Access Request submission for Incident{" " + data.incident_name || ""} has failed. The Access Link is no longer valid.</span> : ""}
            </Card.Body>
          </Card>
        </div>
      </div>
    </span>
    </>
  );
};

export default TemporaryAccessRegistration;